import { throwIfMissing } from '../utils/action.utils';
import { CALL_API } from '../login/api.middleware';
import { CATALOG_SERVICE_URL } from '../constants/api';
import * as type from '../constants/ActionTypes';

export function fetchSalesGroups({
  clientId = throwIfMissing('clientId'),
  salesChannelId
}) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/salesGroups`,
      types: [
        type.SALES_GROUP_REQUEST,
        type.SALES_GROUP_SUCCESS,
        type.SALES_GROUP_FAILURE
      ],
      authenticated: true,
      params: {
        clientId: clientId,
        salesChannelId: salesChannelId
      },
    }
  };
}
